module.exports = __webpack_public_path__ + "static/media/product3.ef1b41a9.jpg";